/* Copyright 2013-2015 The MathWorks, Inc. */

/**
 * This is a list of the component types that can be added to the QAB. The keys are the Component type that can be added
 * to the QAB, the value is the type of control that is created in the QAB and linked with its action.
 */

define([
    "../constants/TypeConstants"
], function (TypeConstants) {
    var hash = {};

    hash[TypeConstants.PUSH_BUTTON] = TypeConstants.QAB_PUSH_BUTTON;
    hash[TypeConstants.DROP_DOWN_BUTTON] = TypeConstants.QAB_DROP_DOWN_BUTTON;
    hash[TypeConstants.SPLIT_BUTTON] = TypeConstants.QAB_SPLIT_BUTTON;
    hash[TypeConstants.TOGGLE_BUTTON] = TypeConstants.QAB_TOGGLE_BUTTON;
    hash[TypeConstants.TOGGLE_SPLIT_BUTTON] = TypeConstants.QAB_TOGGLE_SPLIT_BUTTON;
    hash[TypeConstants.GALLERY_ITEM] = TypeConstants.QAB_PUSH_BUTTON;
    hash[TypeConstants.TOGGLE_GALLERY_ITEM] = TypeConstants.QAB_TOGGLE_BUTTON;
    hash[TypeConstants.LIST_ITEM] = TypeConstants.QAB_PUSH_BUTTON;
    hash[TypeConstants.LIST_ITEM_WITH_POPUP] = TypeConstants.QAB_DROP_DOWN_BUTTON;

    return hash;
});